// Modal.js
import React, { useEffect } from 'react';

const Modal = ({ isOpen, onClose, children }) => {
  const modalClasses = isOpen ? 'block' : 'hidden';

  // Disable background scroll when modal is open
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
    // Cleanup on unmount
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [isOpen]);

  return (
    <div
      className={`fixed z-50 inset-0 overflow-y-auto top-0 my-2 ${modalClasses} `}
    //   onClick={onClose}
    >
      <div className="flex items-center justify-center min-h-screen ">
        <div
          className="fixed inset-0 transition-opacity"
          aria-hidden="true"
        >
          <div className="absolute inset-0 bg-gray-500 opacity-50"></div>
        </div>
        <div className="z-50 w-auto p-4 bg-white rounded-lg mt-3 shadow-lg">
          <div className="relative ">
            {/* <button
              onClick={onClose}
              className="absolute bg-secondary-700 rounded-lg top-0 right-0 p-2 text-white hover:text-gray-700"
            >
              Close
            </button> */}
            {children}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Modal;
